import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Hero from './components/Hero';
import SplitSection from './components/SplitSection';
import GalleryPage from './components/GalleryPage';
import Cursor from './components/Cursor';
import FloatingCV from './components/FloatingCV';
import Footer from './components/Footer';
import { FaInstagram, FaLinkedin, FaTwitter } from 'react-icons/fa';
import ABOUT_IMG from './assets/images/sonam.jpg';
import SNOW_IMG from './assets/images/snow4.jpg';
import HILLS_IMG from './assets/images/hills5.jpg';

// Gallery Images
// Dynamically import all hills images and sort them efficiently
const hillsContext = require.context('./assets/images', false, /hills.*\.jpg$/);
const HILLS_IMAGES = hillsContext.keys()
  .sort((a, b) => {
    // Extract numbers to sort numerically (1, 2, ... 10) instead of alphabetically (1, 10, ... 2)
    const numA = parseInt(a.match(/(\d+)/)[0]);
    const numB = parseInt(b.match(/(\d+)/)[0]);
    return numA - numB;
  })
  .map(hillsContext);

const snowContext = require.context('./assets/images', false, /snow.*\.jpg$/);
const SNOW_IMAGES = snowContext.keys()
  .sort((a, b) => {
    // Extract numbers to sort numerically (1, 2, ... 10) instead of alphabetically (1, 10, ... 2)
    const numA = parseInt(a.match(/(\d+)/)[0]);
    const numB = parseInt(b.match(/(\d+)/)[0]);
    return numA - numB;
  })
  .map(snowContext);

function Home() {
  return (
    <>
      <div style={{ height: '100vh', scrollSnapAlign: 'start' }}>
        <Hero />
      </div>

      <SplitSection 
        title="About Me" 
        imageSrc={ABOUT_IMG} 
        reversed={true}
        content={`
          "I'm a self-taught photographer with a passion for capturing the quiet beauty of the natural world.
          
          From sunlit forests to sweeping mountain views, I'm always chasing moments that tell a story of connection between people and the outdoors.
          
          My work reflects curiosity, patience, and a deep respect for nature's ever-changing light."
        `}
        //extraContent={<FloatingCV />}
      />

      <SplitSection 
        title="The Hills" 
        imageSrc={HILLS_IMG}
        linkTo="/hills"
        imagePosition="center bottom"
        imageObjectFit='cover'
        content={`
          The hills are the breath of the earth.
          
          Green waves that roll endlessly into the horizon, they hold the secrets of the morning mist and the golden hour's embrace.
          
          Here, time slows down, and every path leads to a new discovery, a new silence to be cherished.
        `}
      />

      <SplitSection 
        title="The Snow" 
        imageSrc={SNOW_IMG} 
        reversed={true}
        linkTo="/snow"
        content={`
          The mountains have always been my sanctuary.
          
          Growing up as a Sherpa, the snow isn't just a weather condition; it's a part of our soul.
          It shapes the landscape, the culture, and the silence that speaks louder than words.
          
          Every photograph is a tribute to this heritage.
        `}
      />

      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <Cursor />
      <div className="App" style={{ 
        height: '100vh', 
        overflowY: 'scroll', 
        scrollSnapType: 'y mandatory',
        scrollBehavior: 'smooth',
        overscrollBehavior: 'none'
      }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/hills" element={<GalleryPage title="The Hills" images={HILLS_IMAGES} />} />
          <Route path="/snow" element={<GalleryPage title="The Snow" images={SNOW_IMAGES} />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
